import { liveUsageMgmtSliceSelector } from "../store-selectors/liveUsageMgmtSliceSelector";
import { RootState } from "@/store/store";

export const liveUsageMgmtAppliedTemplateIdSelector = (
  state: RootState,
): string | null => liveUsageMgmtSliceSelector(state).appliedFilterTemplateId;
